var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"新版后台","name":"v1"}},[_c('access-v2')],1),_c('el-tab-pane',{attrs:{"label":"旧版后台","name":"v2"}},[_c('access-v1')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }